// 集成重试机制的HTTP请求模块 - 参考 adjust web sdk 优化

import {
  createHttpError
} from './http';
import {
  ExponentialBackoff,
} from './retry';
import {
  HttpWithRetryOptions,
  HttpWithRetryResponse,
} from './http/types';

// 导入统一的 HTTP 接口
import http from './http';

class NetworkStatusManager {
  // 非 window 环境，默认判断为在线
  private isOnline: boolean = (typeof navigator !== 'undefined' && navigator?.onLine) ?? true
  constructor() {
    addEventListener('online', () => this.setOnline(true));
    addEventListener('offline', () => this.setOnline(false));
  }
  setOnline(online: boolean): void {
    this.isOnline = online;
  }
  isConnected(): boolean {
    return this.isOnline;
  }
}

// 全局网络状态管理器
const networkManager = new NetworkStatusManager();

export async function httpWithRetry(
  url: string,
  options: HttpWithRetryOptions = {}
): Promise<HttpWithRetryResponse> {
  const {
    retry: retryConfig = {},
    enableRetry = true,
    checkNetworkStatus = true,
    ...httpOptions
  } = options;

  // 网络状态检查
  if (checkNetworkStatus && !networkManager.isConnected()) {
    // 网络离线时，抛出错误，让调用方处理
    throw createHttpError('No network connection', 0, 'NO_CONNECTION');
  }

  // 如果不启用重试，直接使用统一的HTTP接口
  if (!enableRetry) {
    const response = await http(url, httpOptions);
    return {
      data: response,
    };
  }

  // 创建重试实例
  const backoff = new ExponentialBackoff(retryConfig);

  const response = await backoff.execute(async () => {
    return await http(url, httpOptions);
  });

  const retryInfo = backoff.getRetryInfo();

  // 添加重试信息到响应
  return {
    data: response,
    retryInfo
  };

}

/**
 * 检查网络连接状态
 */
export function isNetworkConnected(): boolean {
  return networkManager.isConnected();
} 
